import { Outlet } from 'react-router-dom';
import Navbar from "./components/Navbar/Navbar";
import Footer from "./Footer";

export default function Layout({EXTERNAL_LINKS, toggleHamburger, setToggleHamburger, activeLink, setActiveLink}) {
  
  return (
    <>
      <Navbar EXTERNAL_LINKS={EXTERNAL_LINKS} activeLink={activeLink} setActiveLink={setActiveLink} toggleHamburger={toggleHamburger} setToggleHamburger={setToggleHamburger}/>
      <Outlet />
      {(activeLink === "home" || activeLink === "repository" || activeLink === "download") && <Footer EXTERNAL_LINKS={EXTERNAL_LINKS}/>}
    </>
  )
}